import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../ui/alert-dialog';
import { AlertTriangle } from 'lucide-react';

// Action types that can trigger the confirmation
export const PUZZLE_LOSS_ACTIONS = {
  NEW_PUZZLE: 'new_puzzle',
  PREVIOUS_IMAGE: 'previous_image',
  DAILY_CHALLENGE: 'daily_challenge',
  CHALLENGE: 'challenge'
};

// Get action-specific text
const getActionText = (actionType) => {
  switch (actionType) {
    case PUZZLE_LOSS_ACTIONS.NEW_PUZZLE:
      return {
        title: 'Start New Puzzle?',
        description: 'You have a puzzle in progress. Starting a new puzzle will discard your current progress and all moves will be lost.',
        confirmText: 'Start New Puzzle'
      };
    case PUZZLE_LOSS_ACTIONS.PREVIOUS_IMAGE:
      return {
        title: 'Go to Previous Puzzle?',
        description: 'You have a puzzle in progress. Going to the previous puzzle will discard your current progress and all moves will be lost.',
        confirmText: 'Go to Previous'
      };
    case PUZZLE_LOSS_ACTIONS.DAILY_CHALLENGE:
      return {
        title: 'Start Daily Challenge?',
        description: 'You have a puzzle in progress. Starting the Daily Challenge will discard your current progress and all moves will be lost.',
        confirmText: 'Start Daily Challenge'
      };
    case PUZZLE_LOSS_ACTIONS.CHALLENGE:
      return {
        title: 'Start Challenge?',
        description: 'You have a puzzle in progress. Starting this challenge will discard your current progress and all moves will be lost.',
        confirmText: 'Start Challenge'
      };
    default:
      return {
        title: 'Continue?',
        description: 'You have a puzzle in progress. This action will discard your current progress.',
        confirmText: 'Continue'
      };
  }
};

export function NewPuzzleConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
  onCancel,
  actionType = PUZZLE_LOSS_ACTIONS.NEW_PUZZLE
}) {
  const { title, description, confirmText } = getActionText(actionType);
  
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="new-puzzle-confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
            {title}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel} data-testid="new-puzzle-cancel-btn">
            Keep Playing
          </AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} data-testid="new-puzzle-confirm-btn">
            {confirmText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
